import { StepConfig } from "./reducer"

export enum ActionTypes {
    ADVANCE_STEPPER,
    REVERSE_STEPPER,
    RESET,
    UPDATE_NEXT_STEP_CONFIG,
    UPDATE_BACK_STEP_CONFIG
}

interface AdvanceStepperAction {
    type: ActionTypes.ADVANCE_STEPPER
}

export const advanceStepper = (): AdvanceStepperAction => ({
    type: ActionTypes.ADVANCE_STEPPER
})

interface ReverseStepperAction {
    type: ActionTypes.REVERSE_STEPPER
}

export const reverseStepper = (): ReverseStepperAction => ({
    type: ActionTypes.REVERSE_STEPPER
})

interface ResetStepperAction {
    type: ActionTypes.RESET
}

export const resetStepper = (): ResetStepperAction => ({
    type: ActionTypes.RESET
})

interface UpdateNextStepConfig {
    type: ActionTypes.UPDATE_NEXT_STEP_CONFIG
    config: Partial<StepConfig>
}

export const updateNextStep = (config: Partial<StepConfig>): UpdateNextStepConfig => ({
    type: ActionTypes.UPDATE_NEXT_STEP_CONFIG,
    config
})

interface UpdateBackStepConfig {
    type: ActionTypes.UPDATE_BACK_STEP_CONFIG
    config: Partial<StepConfig>
}

export const updateBackStep = (config: Partial<StepConfig>): UpdateBackStepConfig => ({
    type: ActionTypes.UPDATE_BACK_STEP_CONFIG,
    config
})

export type Action =
    | AdvanceStepperAction
    | ReverseStepperAction
    | ResetStepperAction
    | UpdateNextStepConfig
    | UpdateBackStepConfig
